module.exports = __webpack_public_path__ + "img/lifestyle-style-active.76dcbf66.svg";